import { triggerSessionExpired } from "./authSession";

/**
 * Antwort eines rohen fetch() mit Token pruefen: bei 401 die Sitzung zentral
 * beenden (Neuanmeldung mit Hinweis), die Antwort selbst unveraendert
 * zurueckgeben.
 *
 * Fuer Aufrufe, die nicht ueber fetchWithAuth laufen koennen – Datei-Downloads
 * (Blob statt JSON) oder Stellen mit eigener Statusauswertung. Vorher meldeten
 * diese bei abgelaufener Sitzung nur "Fehler" bzw. "keine Verbindung", ohne
 * dass jemand auf die Idee kam, sich neu anzumelden.
 */
export function mitSitzungspruefung(res) {
  if (res && res.status === 401) triggerSessionExpired();
  return res;
}

export async function fetchWithAuth(url, navigate, options = {}) {
  const token = localStorage.getItem("token");

  if (!token) {
    triggerSessionExpired();
    throw new Error("No token found");
  }

  const authOptions = {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  };

  let res;
  try {
    res = await fetch(url, authOptions);
  } catch (err) {
    console.error("[fetchWithAuth] Network error:", err);
    throw new Error("Keine Verbindung zum Server");
  }

  // Handle HTTP errors
  if (!res.ok) {
    if (res.status === 401) {
      triggerSessionExpired();
      throw new Error("Unauthorized");
    }

    // For other errors, try to get error message from response
    // BEHOBENER FEHLER: Gelesen wurde `message`, das Backend liefert seine
    // (deutschen) Meldungen aber durchgehend im Feld `error`. Angezeigt wurde
    // deshalb nur "HTTP 409" o. Ae. statt z. B. "Für dieses Team ist an dieser
    // Station bereits ein Ergebnis eingetragen."
    let errorMsg = getErrorMessage(res.status);
    try {
      const errorData = await res.json();
      errorMsg = errorData.error || errorData.message || errorMsg;
    } catch {
      // Antwort ist kein JSON – bei der Status-Meldung bleiben.
    }
    const err = new Error(errorMsg);
    err.status = res.status;
    throw err;
  }

  // Parse successful response
  try {
    return await res.json();
  } catch (err) {
    console.error("[fetchWithAuth] JSON parse error:", err);
    throw new Error("Invalid response format from server");
  }
}

function getErrorMessage(status) {
  const messages = {
    400: "Ungültige Anfrage",
    403: "Keine Berechtigung für diese Aktion",
    404: "Nicht gefunden",
    409: "Konflikt mit einem bereits vorhandenen Eintrag",
    429: "Zu viele Anfragen – bitte kurz warten",
    500: "Serverfehler – bitte später erneut versuchen",
    503: "Server vorübergehend nicht erreichbar",
  };
  return messages[status] || `Anfrage fehlgeschlagen (HTTP ${status})`;
}
